/* No Bra Club Vol. 14 homepage section — behaviour.
   Layers on the book: WebGL photo (jiggle + depth tilt) · living-cover video · cover type/sticker overlay · heart cursor.
   Intro: a pink particle hologram of her (built from the photo + its depth map) surges out, turns to you, glitches,
   and collapses back into the book. Quick wins: zone-aware texts, heart burst, sound toggle, drop countdown, notify form. */
(() => {
  const $ = id => document.getElementById(id);
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = $('n14-club'), MUSIC_SRC = (window.NBC14 || {}).music || '';   // theme: section setting music_url ('' = SFX only)
  const CFG = window.NBC14 || {}, FLAGS = CFG.flags || {};
  const DROP = new Date(CFG.drop || '2026-09-25T00:00:00-04:00');          // Steven 09-24: drops tonight, Sep 25 12:00 am ET

  // ---------- marquee + underboob edge ----------
  const boob = '<svg viewBox="0 0 30 16" aria-hidden="true"><path d="M1 2c0 7 5 12 7 12s6-3 7-8c1 5 5 8 7 8s7-5 7-12" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/></svg>';
  const words = ['NO BRA CLUB', 'VOL. 14', 'FT. HIEN HONEYBEE', 'DIGITAL EXCLUSIVE', 'THE CHAMP GOES NO BRA', 'UNDERBOOB SEASON', 'OILED UP & BARELY COVERED'];
  const run = words.map(w => `<span>${w}</span>${boob}`).join('');
  $('n14Track').innerHTML = run + run + run + run;
  (() => {
    let d = 'M0 34 L0 0'; const n = 12, w = 1200 / n;
    for (let i = 0; i < n; i++) { const x = i * w; d += ` Q${x + w * .25} 30 ${x + w * .5} 6 Q${x + w * .75} 30 ${x + w} 0`; }
    $('n14EdgePath').setAttribute('d', d + ' L1200 34 Z');
  })();

  const wrap = $('n14Wrap'), bookEl = wrap.querySelector('.n14-book'), hero = $('n14Hero'), canvas = $('n14GL');
  const alive = $('n14Alive'), hint = $('n14Hint'), cursor = $('n14Cursor'), mark = $('n14Mark'), chat = $('n14Chat');
  const holo = $('n14Holo'), hearts = $('n14Hearts'), sfxBtn = $('n14Sfx'), peekBtn = $('n14Peek');
  const ease = { out: x => 1 - Math.pow(1 - x, 3), io: x => x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2 };
  const glitchMark = () => { if (reduce) return; mark.classList.remove('is-glitch'); void mark.offsetWidth; mark.classList.add('is-glitch'); };

  // ---------- sound (off by default; browsers only allow it after a tap) ----------
  const Sfx = {
    on: false, ctx: null,
    toggle() {
      try { this.ctx = this.ctx || new (window.AudioContext || window.webkitAudioContext)(); this.ctx.resume(); } catch (e) { return; }
      this.on = !this.on; sfxBtn.setAttribute('aria-pressed', this.on); sfxBtn.textContent = this.on ? '🔊 Sound on' : '🔈 Sound off';
      if (this.on) this.pop(1.4);
      this.music(this.on);
    },
    // Steven 09-25: his track (Resolve timeline NBC14_home_teaser_v2, Audio 2) loops under the SFX while sound is on
    track: null, inView: true,
    music(play) {
      if (!MUSIC_SRC) return;
      if (!this.track) { this.track = new Audio(MUSIC_SRC); this.track.loop = true; this.track.preload = 'auto'; }
      if (play && this.inView && !document.hidden) this.track.play().catch(() => {}); else this.track.pause();
    },
    env(g, a, d, peak) { const t = this.ctx.currentTime; g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(peak, t + a); g.gain.exponentialRampToValueAtTime(.0001, t + a + d); },
    noise(dur) { const b = this.ctx.createBuffer(1, this.ctx.sampleRate * dur, this.ctx.sampleRate), d = b.getChannelData(0); for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1; const s = this.ctx.createBufferSource(); s.buffer = b; return s; },
    hum(dur) {
      if (!this.on) return; const c = this.ctx, g = c.createGain(), f = c.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 900;
      [55, 110.5, 220.8].forEach((hz, i) => { const o = c.createOscillator(); o.type = i ? 'triangle' : 'sine'; o.frequency.value = hz; o.connect(f); o.start(); o.stop(c.currentTime + dur); });
      f.connect(g); g.connect(c.destination); this.env(g, .5, dur - .5, .09);
    },
    crackle(k = 1) {
      if (!this.on) return; const c = this.ctx, s = this.noise(.09), f = c.createBiquadFilter(), g = c.createGain();
      f.type = 'bandpass'; f.frequency.value = 2400 + Math.random() * 2000; f.Q.value = 3; s.connect(f); f.connect(g); g.connect(c.destination); this.env(g, .005, .08, .12 * k); s.start();
    },
    pop(k = 1) {
      if (!this.on) return; const c = this.ctx, o = c.createOscillator(), g = c.createGain(), t = c.currentTime;
      o.type = 'sine'; o.frequency.setValueAtTime(880 * k, t); o.frequency.exponentialRampToValueAtTime(440 * k, t + .09); o.connect(g); g.connect(c.destination); this.env(g, .004, .12, .07); o.start(); o.stop(t + .2);
    }
  };
  if (sfxBtn) sfxBtn.addEventListener('click', () => Sfx.toggle());
  // the music pauses while the section is off screen or the tab is hidden, and picks up again when it's back (sound still on)
  new IntersectionObserver(es => { Sfx.inView = es[0].isIntersecting; if (Sfx.on) Sfx.music(true); }, { threshold: .15 }).observe(root);
  document.addEventListener('visibilitychange', () => { if (Sfx.on) Sfx.music(true); });

  // ---------- jiggle physics: two springs (her left / right breast), UV space of the photo ----------
  const A = [{ x: .40, y: .555, dx: 0, dy: 0, vx: 0, vy: 0 }, { x: .625, y: .555, dx: 0, dy: 0, vx: 0, vy: 0 }];
  const R = { x: .12, y: .1 }, K = 190, C = 6.2, MAX = .028;
  let glitch = 0, energy = 0, lastPoke = 0;
  // pose 28 bust cut-out leaning out over the book (09-24): its own two springs, UV of img/bust_cutout.webp
  const B = [{ x: 0.347, y: 0.91, dx: 0, dy: 0, vx: 0, vy: 0 }, { x: 0.669, y: 0.91, dx: 0, dy: 0, vx: 0, vy: 0 }], RB = { x: .12, y: .085 };   // img/bust_on_book.webp
  const kick = (ix, iy) => [...A, ...B].forEach((a, i) => { const f = i % 2 ? .85 : 1; a.vx += ix * f; a.vy += iy * f; });
  const nearWeight = (a, u, v) => { const ex = (u - a.x) / (R.x * 1.25), ey = (v - a.y) / (R.y * 1.25); return Math.max(0, 1 - Math.hypot(ex, ey)); };

  // ---------- 3D tilt target (mouse on desktop, scroll on phones) ----------
  const tilt = { x: 0, y: 0, tx: 0, ty: 0 };
  addEventListener('pointermove', e => {
    if (e.pointerType !== 'mouse') return;
    const r = bookEl.getBoundingClientRect();
    tilt.tx = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width * 1.2)));
    tilt.ty = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height * 1.2)));
  }, { passive: true });

  // ---------- pointer on her ----------
  let pu = null, pv = null, pt = 0, faceSince = 0, lastFace = 0, lastPointer = 0;
  const uvOf = e => { const r = hero.getBoundingClientRect(); return [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height, r]; };
  hero.addEventListener('pointermove', e => {
    const [u, v, r] = uvOf(e), now = performance.now(); lastPointer = now;
    cursor.style.transform = `translate(${e.clientX - r.left}px,${e.clientY - r.top}px)`;
    if (pu != null) {
      const dt = Math.max(8, now - pt) / 1000, su = (u - pu) / dt, sv = (v - pv) / dt;
      A.forEach(a => { const w = nearWeight(a, u, v); if (w > 0) { a.vx += su * w * .09; a.vy += sv * w * .09; } });
    }
    // zone-aware: linger on her face and she calls you on it
    const onFace = u > .38 && u < .62 && v > .08 && v < .3;
    if (onFace) { faceSince = faceSince || now; if (now - faceSince > 450 && now - lastFace > 9000 && !busy) { lastFace = now; say(["eyes up here 😏"]); } }
    else faceSince = 0;
    if (livePlaying) cutAlive();
    pu = u; pv = v; pt = now; interacted();
  });
  hero.addEventListener('pointerleave', () => { pu = pv = null; faceSince = 0; });
  hero.addEventListener('pointerdown', e => {
    const [u, v] = uvOf(e); let hit = false; lastPointer = performance.now();
    A.forEach(a => { const w = nearWeight(a, u, v); if (w > 0) { hit = true; a.vy += .55 + w * .5; a.vx += (u - a.x) * -3; } });
    if (!hit) kick(0, .35);
    heartBurst(e); if (livePlaying) cutAlive(); poke(); interacted();
  });
  hero.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); kick(0, .7); poke(); interacted(); } });

  // scroll = bounce + tilt (the phone hook)
  let lastY = scrollY, lastT = performance.now();
  addEventListener('scroll', () => {
    const now = performance.now(), dy = scrollY - lastY, dt = Math.max(8, now - lastT) / 1000;
    if (!visible) { lastY = scrollY; lastT = now; return; }
    const r = hero.getBoundingClientRect();
    if (r.bottom > 0 && r.top < innerHeight) {
      const vel = Math.max(-3000, Math.min(3000, dy / dt));
      [...A, ...B].forEach((a, i) => { a.vy += -vel * .00011 * (i % 2 ? .9 : 1); a.vx += vel * .00002 * (i % 2 ? -1 : 1); });
      if (matchMedia('(hover:none)').matches) tilt.ty = Math.max(-1, Math.min(1, ((r.top + r.height / 2) - innerHeight / 2) / innerHeight * 2));
      if (Math.abs(vel) > 400) interacted();
    }
    lastY = scrollY; lastT = now;
  }, { passive: true });

  let hinted = false;
  function interacted() { if (!hinted) { hinted = true; setTimeout(() => hint.classList.add('is-gone'), 900); } }

  // ---------- heart burst ----------
  function heartBurst(e) {
    if (reduce) return;
    const r = wrap.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
    for (let i = 0; i < 8; i++) {
      const h = document.createElement('i'); h.className = 'n14-heart'; h.style.left = x + 'px'; h.style.top = y + 'px';
      h.style.setProperty('--s', (.6 + Math.random() * .7).toFixed(2)); hearts.appendChild(h);
      const dx = (Math.random() - .5) * 170, dy = -(70 + Math.random() * 150), rot = (Math.random() - .5) * 70;
      h.animate([{ transform: 'translate(-50%,-50%) scale(.2)', opacity: 1 },
                 { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) rotate(${rot}deg) scale(1)`, opacity: 0 }],
                { duration: 900 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = () => h.remove();
    }
    Sfx.pop(1 + Math.random() * .3);
  }

  // ---------- WebGL photo: jiggle + depth tilt + glitch ----------
  let gl, uO, uG, uTilt, ok = false;
  const photo = new Image(), depthImg = new Image();
  photo.crossOrigin = depthImg.crossOrigin = 'anonymous';   // Shopify CDN: WebGL + getImageData need CORS-clean images
  // speed 10-14: images + WebGL start only when the section comes near the screen (it used to run at page load)
  const near = new Promise(res => { const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); res(); } }, { rootMargin: '400px 0px' }); io.observe(root); });
  near.then(() => { photo.src = CFG.hero; depthImg.src = CFG.depth; });
  const loaded = img => img._ready || (img._ready = img.complete && img.naturalWidth && img.src ? Promise.resolve() : new Promise(r => { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); }));
  function mkTex(g, img, unit) {
    const t = g.createTexture(); g.activeTexture(g.TEXTURE0 + unit); g.bindTexture(g.TEXTURE_2D, t);
    [[g.TEXTURE_MIN_FILTER, g.LINEAR], [g.TEXTURE_MAG_FILTER, g.LINEAR], [g.TEXTURE_WRAP_S, g.CLAMP_TO_EDGE], [g.TEXTURE_WRAP_T, g.CLAMP_TO_EDGE]].forEach(([k, x]) => g.texParameteri(g.TEXTURE_2D, k, x));
    g.texImage2D(g.TEXTURE_2D, 0, g.RGB, g.RGB, g.UNSIGNED_BYTE, img); return t;
  }
  function program(g, vs, fs) {
    const sh = (t, s) => { const o = g.createShader(t); g.shaderSource(o, s); g.compileShader(o); if (!g.getShaderParameter(o, g.COMPILE_STATUS)) { console.warn('nbc shader:', g.getShaderInfoLog(o)); return null; } return o; };
    const v = sh(g.VERTEX_SHADER, vs), f = sh(g.FRAGMENT_SHADER, fs); if (!v || !f) return null;
    const p = g.createProgram(); g.attachShader(p, v); g.attachShader(p, f); g.linkProgram(p);
    if (!g.getProgramParameter(p, g.LINK_STATUS)) { console.warn('nbc link:', g.getProgramInfoLog(p)); return null; } return p;
  }
  function initGL() {
    gl = canvas.getContext('webgl', { premultipliedAlpha: false, antialias: false }); if (!gl) return false;
    const pr = program(gl, `attribute vec2 p;varying vec2 v;void main(){v=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}`,
      `precision mediump float;varying vec2 v;uniform sampler2D t,dp;uniform vec2 a0,a1,o0,o1,rr,tl;uniform float g;
       vec2 warp(vec2 uv,vec2 a,vec2 o){vec2 e=(uv-a)/rr;float d=length(e);float w=smoothstep(1.,0.,d);w=w*w*(3.-2.*w);
         vec2 s=vec2(-o.y*.35,o.y*.9)*w;return uv-o*w-(uv-a)*s;}
       void main(){vec2 uv=warp(warp(v,a0,o0),a1,o1);
         float d=texture2D(dp,uv).r;uv+=tl*(d-.35)*.022;
         float sp=g*.012;vec4 c=texture2D(t,uv);float r=texture2D(t,uv+vec2(sp,0.)).r;float b=texture2D(t,uv-vec2(sp,0.)).b;
         vec3 col=vec3(r,c.g,b);col=mix(col,col*vec3(1.08,.86,.96)+vec3(.08,0.,.03),g*.55);gl_FragColor=vec4(col,1.);}`);
    if (!pr) return false; gl.useProgram(pr);
    const b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    mkTex(gl, photo, 0); mkTex(gl, depthImg, 1);
    const U = n => gl.getUniformLocation(pr, n);
    gl.uniform1i(U('t'), 0); gl.uniform1i(U('dp'), 1);
    gl.uniform2f(U('a0'), A[0].x, A[0].y); gl.uniform2f(U('a1'), A[1].x, A[1].y); gl.uniform2f(U('rr'), R.x, R.y);
    uO = [U('o0'), U('o1')]; uG = U('g'); uTilt = U('tl');
    return true;
  }
  function size() {
    const r = hero.getBoundingClientRect(), d = Math.min(devicePixelRatio || 1, 2);
    canvas.width = Math.round(r.width * d); canvas.height = Math.round(r.height * d); if (ok) gl.viewport(0, 0, canvas.width, canvas.height);
  }
  Promise.all([loaded(photo), loaded(depthImg)]).then(() => {
    try { ok = initGL(); } catch (e) { ok = false; }
    if (!ok) { hero.classList.add('no-gl'); canvas.remove(); return; }
    size(); addEventListener('resize', size); wake();
  });

  // ---------- the bust cut-out: its own transparent WebGL layer ----------
  const bustCv = $('n14Bust'), bustImg = new Image(); bustImg.crossOrigin = 'anonymous'; near.then(() => { bustImg.src = bustCv ? bustCv.dataset.src : ''; });
  let bg = null, bU = {}, bOk = false, bH = 0, bRv = 2;
  function initBust() {
    bg = bustCv.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false }); if (!bg) return false;
    const pr = program(bg, `attribute vec2 p;varying vec2 v;void main(){v=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}`,
      `precision mediump float;varying vec2 v;uniform sampler2D t;uniform vec2 a0,a1,o0,o1,rr;uniform float g,h,rv,tf;
       float hs(float n){return fract(sin(n)*43758.5453);}
       vec2 warp(vec2 uv,vec2 a,vec2 o){vec2 e=(uv-a)/rr;float d=length(e);float w=smoothstep(1.,0.,d);w=w*w*(3.-2.*w);
         vec2 s=vec2(-o.y*.35,o.y*.9)*w;return uv-o*w-(uv-a)*s;}
       void main(){vec2 uv=warp(warp(v,a0,o0),a1,o1);
         float band=floor(v.y*48.);if(hs(band+floor(tf*18.))<h*.22)uv.x+=(hs(band*2.7+tf)-.5)*.05*h;
         float sp=g*.012+h*.012;
         vec4 c=texture2D(t,uv);float r=texture2D(t,uv+vec2(sp,0.)).r;float b=texture2D(t,uv-vec2(sp,0.)).b;
         vec4 o=vec4(r,c.g,b,c.a);
         if(h>0.){float l=dot(c.rgb/max(c.a,.001),vec3(.299,.587,.114));
           vec3 hc=mix(vec3(.72,.08,.38),vec3(1.,.5,.75),smoothstep(.15,.85,l))+vec3(.25,.75,.95)*pow(1.-l,4.)*.35;
           float sc=.72+.28*sin(gl_FragCoord.y*1.9-tf*30.);
           o=mix(o,vec4(hc*c.a*sc*.9,c.a*sc*.9),h);
           float y=1.-v.y;o*=1.-smoothstep(rv-.035,rv,y);
           o.rgb+=vec3(1.,.55,.82)*smoothstep(.035,0.,abs(y-rv))*c.a*h;}
         gl_FragColor=o;}`);
    if (!pr) return false; bg.useProgram(pr);
    const buf = bg.createBuffer(); bg.bindBuffer(bg.ARRAY_BUFFER, buf); bg.bufferData(bg.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), bg.STATIC_DRAW);
    const loc = bg.getAttribLocation(pr, 'p'); bg.enableVertexAttribArray(loc); bg.vertexAttribPointer(loc, 2, bg.FLOAT, false, 0, 0);
    bg.pixelStorei(bg.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
    const tx = bg.createTexture(); bg.bindTexture(bg.TEXTURE_2D, tx);
    [[bg.TEXTURE_MIN_FILTER, bg.LINEAR], [bg.TEXTURE_MAG_FILTER, bg.LINEAR], [bg.TEXTURE_WRAP_S, bg.CLAMP_TO_EDGE], [bg.TEXTURE_WRAP_T, bg.CLAMP_TO_EDGE]].forEach(([k, x]) => bg.texParameteri(bg.TEXTURE_2D, k, x));
    bg.texImage2D(bg.TEXTURE_2D, 0, bg.RGBA, bg.RGBA, bg.UNSIGNED_BYTE, bustImg);
    const U = n => bg.getUniformLocation(pr, n);
    bg.uniform2f(U('a0'), B[0].x, B[0].y); bg.uniform2f(U('a1'), B[1].x, B[1].y); bg.uniform2f(U('rr'), RB.x, RB.y);
    bU = { o0: U('o0'), o1: U('o1'), g: U('g'), h: U('h'), rv: U('rv'), tf: U('tf') }; bg.uniform1f(bU.rv, 2); return true;
  }
  function sizeBust() { const r = bustCv.getBoundingClientRect(), d = Math.min(devicePixelRatio || 1, 2); bustCv.width = Math.round(r.width * d); bustCv.height = Math.round(r.height * d); if (bOk) bg.viewport(0, 0, bustCv.width, bustCv.height); }
  if (bustCv) loaded(bustImg).then(() => {
    try { bOk = initBust(); } catch (e) { bOk = false; }
    if (!bOk) { bustCv.classList.add('no-gl'); return; }
    sizeBust(); addEventListener('resize', sizeBust);
    const nearB = (a, u, v) => { const ex = (u - a.x) / (RB.x * 1.25), ey = (v - a.y) / (RB.y * 1.25); return Math.max(0, 1 - Math.hypot(ex, ey)); };
    const uvB = e => { const r = bustCv.getBoundingClientRect(); return [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height]; };
    let bu = null, bv = null, bt = 0;
    bustCv.addEventListener('pointermove', e => { const [u, v] = uvB(e), now = performance.now(); lastPointer = now;
      if (bu != null) { const dt = Math.max(8, now - bt) / 1000, su = (u - bu) / dt, sv = (v - bv) / dt; B.forEach(a => { const w = nearB(a, u, v); if (w > 0) { a.vx += su * w * .09; a.vy += sv * w * .09; } }); }
      bu = u; bv = v; bt = now; interacted(); });
    bustCv.addEventListener('pointerleave', () => { bu = bv = null; });
    bustCv.addEventListener('pointerdown', e => { const [u, v] = uvB(e); let hit = false; lastPointer = performance.now();
      B.forEach(a => { const w = nearB(a, u, v); if (w > 0) { hit = true; a.vy += .55 + w * .5; a.vx += (u - a.x) * -3; } });
      if (!hit) B.forEach(a => { a.vy += .35; }); heartBurst(e); poke(); interacted(); });
  });
  // Steven 09-25: she materialises the way the book's hologram does, instead of dropping in. Particles sampled from the cut-out
  // stream up out of the book's top edge into her shape, the image sweeps in from the book upward as a pink scan-lined hologram,
  // then resolves to full colour and plops (springs).
  const plop = () => B.forEach(a => { a.vy += 1.1; });
  function bustHolo(finish) {
    const W = bustCv.clientWidth, H = bustCv.clientHeight, dpr = Math.min(devicePixelRatio || 1, 2);
    const cv = document.createElement('canvas'); cv.className = 'n14-bustHolo'; cv.setAttribute('aria-hidden', 'true');
    Object.assign(cv.style, { left: bustCv.offsetLeft + 'px', top: bustCv.offsetTop + 'px', width: W + 'px', height: H + 'px' });
    bustCv.after(cv); cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    let hg = null; try { hg = cv.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false }); } catch (e) {}
    const GW = 150, GH = Math.round(GW * bustImg.naturalHeight / bustImg.naturalWidth);
    let data = null;
    try { const sc = document.createElement('canvas'); sc.width = GW; sc.height = GH; const sx = sc.getContext('2d', { willReadFrequently: true });
      sx.drawImage(bustImg, 0, 0, GW, GH); data = sx.getImageData(0, 0, GW, GH).data; } catch (e) {}
    if (!hg || !data) { cv.remove(); return finish(false); }
    const pos = [], col = [], rnd = [];
    for (let y = 0; y < GH; y++) for (let x = 0; x < GW; x++) {
      const i = (y * GW + x) * 4; if (data[i + 3] < 140) continue;
      pos.push((x + Math.random() * .6) / GW, (y + Math.random() * .6) / GH);
      col.push(data[i] / 255, data[i + 1] / 255, data[i + 2] / 255);
      rnd.push(Math.random() * 2 - 1, Math.random() * 2 - 1, Math.random() * 2 - 1, Math.random());
    }
    const N = pos.length / 2;
    const pr = program(hg,
      `attribute vec2 aP;attribute vec3 aC;attribute vec4 aR;uniform float uAs,uT,uGk,uPt;varying vec3 vC;varying float vA;
       float hs(float n){return fract(sin(n)*43758.5453);}
       void main(){
         float k=clamp((uAs-(1.-aP.y)*.45-aR.w*.2)/.35,0.,1.);k=k*k*(3.-2.*k);
         vec2 tg=vec2(aP.x*2.-1.,1.-aP.y*2.);
         vec2 sr=vec2(tg.x*.55+aR.x*.18,-.88+aR.y*.05);
         vec2 p=mix(sr,tg,k);p.x+=sin(uT*9.+aP.y*30.)*.025*(1.-k);
         float band=floor(aP.y*40.);if(hs(band+floor(uT*16.))<uGk*.4)p.x+=(hs(band*3.1+uT)-.5)*.12*uGk;
         gl_Position=vec4(p,0.,1.);gl_PointSize=uPt*(.75+aR.w*.5);vC=aC;vA=mix(.3,1.,k);}`,
      `precision mediump float;varying vec3 vC;varying float vA;uniform float uAmt,uTf;
       void main(){vec2 q=gl_PointCoord-.5;float d=length(q);if(d>.5)discard;
         float l=dot(vC,vec3(.299,.587,.114));
         vec3 c=mix(vec3(.72,.08,.38),vec3(1.,.5,.75),smoothstep(.15,.85,l))+vec3(.25,.75,.95)*pow(1.-l,4.)*.35;
         float scan=.7+.3*sin(gl_FragCoord.y*1.9-uTf*30.);
         float a=smoothstep(.5,.15,d)*uAmt*vA*scan*.8;gl_FragColor=vec4(c*a,a);}`);
    if (!pr) { cv.remove(); return finish(false); }
    hg.useProgram(pr);
    const buf = (d, name, n) => { const b = hg.createBuffer(); hg.bindBuffer(hg.ARRAY_BUFFER, b); hg.bufferData(hg.ARRAY_BUFFER, new Float32Array(d), hg.STATIC_DRAW);
      const l = hg.getAttribLocation(pr, name); hg.enableVertexAttribArray(l); hg.vertexAttribPointer(l, n, hg.FLOAT, false, 0, 0); };
    buf(pos, 'aP', 2); buf(col, 'aC', 3); buf(rnd, 'aR', 4);
    hg.enable(hg.BLEND); hg.blendFunc(hg.ONE, hg.ONE_MINUS_SRC_ALPHA); hg.viewport(0, 0, cv.width, cv.height);
    const U = n => hg.getUniformLocation(pr, n);
    const u = { as: U('uAs'), t: U('uT'), gk: U('uGk'), pt: U('uPt'), amt: U('uAmt'), tf: U('uTf') };
    hg.uniform1f(u.pt, Math.max(1.6, W / GW * dpr * 1.45));
    Sfx.hum(2.2);
    const D = 2300, t0 = performance.now(); let lastCrack = 0;
    (function frame(now) {
      const p = Math.min(1, (now - t0) / D);
      const as = ease.out(Math.min(1, p / .55)) * 1.45;
      const amt = p < .05 ? (Math.random() > .4 ? .7 : .15) : p < .62 ? 1 : Math.max(0, 1 - (p - .62) / .22);
      const spike = (p > .3 && p < .36) || (p > .58 && p < .64) || Math.random() < .03;
      if (spike && now - lastCrack > 140) { lastCrack = now; Sfx.crackle(.6); glitch = Math.max(glitch, .5); }
      bRv = ease.io(Math.min(1, Math.max(0, (p - .32) / .36))) * 1.08;
      bH = p < .7 ? 1 : Math.max(0, 1 - (p - .7) / .24);
      hg.clearColor(0, 0, 0, 0); hg.clear(hg.COLOR_BUFFER_BIT);
      hg.uniform1f(u.as, as); hg.uniform1f(u.t, now / 1000); hg.uniform1f(u.tf, now / 1000); hg.uniform1f(u.gk, spike ? .9 : .12); hg.uniform1f(u.amt, amt);
      hg.drawArrays(hg.POINTS, 0, N);
      if (p < 1) requestAnimationFrame(frame); else { cv.remove(); finish(true); }
    })(t0);
  }
  const revealBust = () => {
    if (!bustCv) return;
    if (reduce || !bOk) { bookEl.classList.add('is-out'); setTimeout(plop, 380); return; }   // no WebGL / reduced motion: the old drop-in
    bH = 1; bRv = 0; bookEl.classList.add('is-holo', 'is-out');
    bustHolo(ok => { bH = 0; bRv = 2; setTimeout(plop, ok ? 0 : 380); });
  };

  let prev = performance.now(), idleAt = performance.now() + 2500, visible = true;
  let looping = false;
  const wake = () => { if (!looping && ok) { looping = true; prev = performance.now(); requestAnimationFrame(loop); } };
  new IntersectionObserver(es => { visible = es[0].isIntersecting; if (visible) wake(); }, { threshold: 0 }).observe(hero);
  // CSS loops (marquee, pulses) pause while the whole section is off screen
  new IntersectionObserver(es => { root.classList.toggle('n14-off', !es[0].isIntersecting); }, { threshold: 0 }).observe(root);
  function loop(now) {
    const dt = Math.min(.033, (now - prev) / 1000); prev = now; energy = 0;
    [...A, ...B].forEach(a => {
      a.vx += (-K * a.dx - C * a.vx) * dt; a.vy += (-K * a.dy - C * a.vy) * dt; a.dx += a.vx * dt; a.dy += a.vy * dt;
      a.dx = Math.max(-MAX, Math.min(MAX, a.dx)); a.dy = Math.max(-MAX, Math.min(MAX, a.dy)); energy += Math.abs(a.vx) + Math.abs(a.vy);
    });
    if (energy > 2.2 && !reduce) { glitch = Math.min(1, glitch + .5); if (now - lastPoke > 2600) poke(); }
    glitch *= .86;
    if (!reduce && visible && now > idleAt && !livePlaying) { kick(0, .28); idleAt = now + 5200 + Math.random() * 2500; }
    if (energy > .05) idleAt = Math.max(idleAt, now + 4000);
    tilt.x += (tilt.tx - tilt.x) * .08; tilt.y += (tilt.ty - tilt.y) * .08;
    if (visible) {
      if (!reduce) bookEl.style.transform = `perspective(1300px) rotateY(${(tilt.x * 7).toFixed(2)}deg) rotateX(${(-tilt.y * 5).toFixed(2)}deg)`;
      gl.uniform2f(uO[0], A[0].dx, A[0].dy); gl.uniform2f(uO[1], A[1].dx, A[1].dy); gl.uniform1f(uG, glitch);
      gl.uniform2f(uTilt, reduce ? 0 : tilt.x, reduce ? 0 : tilt.y); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      if (bOk) { bg.uniform2f(bU.o0, B[0].dx, B[0].dy); bg.uniform2f(bU.o1, B[1].dx, B[1].dy); bg.uniform1f(bU.g, glitch);
        bg.uniform1f(bU.h, bH); bg.uniform1f(bU.rv, bRv); bg.uniform1f(bU.tf, now / 1000);
        bg.clearColor(0, 0, 0, 0); bg.clear(bg.COLOR_BUFFER_BIT); bg.drawArrays(bg.TRIANGLE_STRIP, 0, 4); }
    }
    if (visible || energy > .01) requestAnimationFrame(loop); else looping = false;
  }

  // ---------- living cover: the photo glitch-cuts into her clip of the same moment, then back ----------
  let livePlaying = false, liveTimer = 0;
  function flashCut() { if (reduce) return; hero.classList.remove('is-cut'); void hero.offsetWidth; hero.classList.add('is-cut'); glitch = 1; Sfx.crackle(1.2); }
  function playAlive() {
    if (livePlaying || !visible || document.hidden || performance.now() - lastPointer < 4000) { scheduleAlive(4000); return; }
    livePlaying = true; flashCut(); alive.currentTime = 0;
    alive.play().then(() => hero.classList.add('is-alive')).catch(() => { livePlaying = false; });
  }
  function cutAlive() { if (!livePlaying) return; flashCut(); hero.classList.remove('is-alive'); alive.pause(); livePlaying = false; scheduleAlive(14000); }
  alive.addEventListener('ended', () => { cutAlive(); });
  function scheduleAlive(ms) { clearTimeout(liveTimer); if (!reduce && FLAGS.alive !== false) liveTimer = setTimeout(playAlive, ms); }

  // ---------- her texts ----------
  const lines = [['hey you.', 'glad you made it'], ["you're staring.", 'i like it'], ['the oil was my idea'], ['this is my competition face'],
                 ["don't pretend you're not looking"], ['closer.', "i don't bite"], ['did it get warm in here?'], ["i know what you're looking at"]];
  const reacts = [['careful...'], ['did you just poke me?'], ['again? 😳'], ["ok now you're just playing"], ['they bounce back. promise']];
  let li = 0, ri = 0, busy = false, timer;
  function say(set) {
    busy = true; clearTimeout(timer); chat.querySelectorAll('.n14-bub').forEach(b => b.remove());
    let k = 0;
    const step = () => {
      const typing = document.createElement('div'); typing.className = 'n14-bub typing'; typing.innerHTML = '<i></i><i></i><i></i>'; chat.appendChild(typing);
      timer = setTimeout(() => {
        typing.remove(); const b = document.createElement('div'); b.className = 'n14-bub'; b.textContent = set[k++]; chat.appendChild(b); Sfx.pop(1.2);
        if (k < set.length) timer = setTimeout(step, 700); else { busy = false; timer = setTimeout(next, 3600); }
      }, reduce ? 150 : 850);
    };
    step();
  }
  function next() { say(lines[li++ % lines.length]); }
  function poke() { lastPoke = performance.now(); glitchMark(); Sfx.crackle(.6); say(reacts[ri++ % reacts.length]); }

  // ---------- particle hologram intro ----------
  function startIntro(done) {
    let hg = null; try { hg = holo.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false }); } catch (e) {}
    const bail = () => { holo.remove(); wrap.classList.remove('is-arming'); revealBust(); done(); };
    if (reduce || !hg || FLAGS.holo === false) return bail();
    Promise.all([loaded(photo), loaded(depthImg)]).then(() => {
      // sample her photo + depth on a grid; keep the points that are her (near), drop the room
      const GW = 190, GH = 253, cv = document.createElement('canvas'); cv.width = GW; cv.height = GH;
      const cx = cv.getContext('2d', { willReadFrequently: true });
      cx.drawImage(photo, 0, 0, GW, GH); const pc = cx.getImageData(0, 0, GW, GH).data;
      cx.drawImage(depthImg, 0, 0, GW, GH); const dc = cx.getImageData(0, 0, GW, GH).data;
      const pos = [], col = [], rnd = [];
      for (let y = 0; y < GH; y++) for (let x = 0; x < GW; x++) {
        const i = (y * GW + x) * 4, d = dc[i] / 255;
        if (d < .45 && Math.random() > .025) continue;                 // mostly her; a few room sparks
        pos.push((x + Math.random() * .6) / GW, (y + Math.random() * .6) / GH, d);
        col.push(pc[i] / 255, pc[i + 1] / 255, pc[i + 2] / 255);
        rnd.push(Math.random() * 2 - 1, Math.random() * 2 - 1, Math.random() * 2 - 1, Math.random());
      }
      const N = pos.length / 3;
      const pr = program(hg,
        `attribute vec3 aP;attribute vec3 aC;attribute vec4 aR;uniform float uAs,uSc,uRot,uPush,uFlat,uT,uGk,uPt,uAsp;varying vec3 vC;varying float vA;
         float h(float n){return fract(sin(n)*43758.5453);}
         void main(){
           float k=clamp((uAs-aR.w*.35)/.65,0.,1.);k=k*k*(3.-2.*k);
           vec3 w=vec3((aP.x-.5)*.75,(.5-aP.y),(aP.z-.5)*.5*(1.-uFlat));
           vec3 sc=aR.xyz*vec3(1.6,1.6,1.2);
           vec3 p=mix(sc,w,k);
           float band=floor(aP.y*40.);if(h(band+floor(uT*16.))<uGk*.4)p.x+=(h(band*3.1+uT)-.5)*.14*uGk;
           float c=cos(uRot),s=sin(uRot);p=vec3(p.x*c+p.z*s,p.y,-p.x*s+p.z*c);
           p*=uSc;p.z+=uPush;
           float per=2.4/(2.4-p.z);
           gl_Position=vec4(p.x*per/(.75*uAsp),p.y*per,0.,1.);
           gl_PointSize=uPt*per*(.75+aR.w*.5);
           vC=aC;vA=mix(.35,1.,k);}`,
        `precision mediump float;varying vec3 vC;varying float vA;uniform float uAmt,uTf;
         void main(){vec2 q=gl_PointCoord-.5;float d=length(q);if(d>.5)discard;
           float l=dot(vC,vec3(.299,.587,.114));
           vec3 c=mix(vec3(.72,.08,.38),vec3(1.,.5,.75),smoothstep(.15,.85,l))+vec3(.25,.75,.95)*pow(1.-l,4.)*.35;
           float scan=.7+.3*sin(gl_FragCoord.y*1.9-uTf*30.);
           float a=smoothstep(.5,.15,d)*uAmt*vA*scan*.72;gl_FragColor=vec4(c*a,a);}`);
      if (!pr) return bail();
      hg.useProgram(pr);
      const buf = (data, name, n) => { const b = hg.createBuffer(); hg.bindBuffer(hg.ARRAY_BUFFER, b); hg.bufferData(hg.ARRAY_BUFFER, new Float32Array(data), hg.STATIC_DRAW);
        const l = hg.getAttribLocation(pr, name); hg.enableVertexAttribArray(l); hg.vertexAttribPointer(l, n, hg.FLOAT, false, 0, 0); };
      buf(pos, 'aP', 3); buf(col, 'aC', 3); buf(rnd, 'aR', 4);
      hg.enable(hg.BLEND); hg.blendFunc(hg.ONE, hg.ONE_MINUS_SRC_ALPHA);
      const U = n => hg.getUniformLocation(pr, n);
      const u = { as: U('uAs'), sc: U('uSc'), rot: U('uRot'), push: U('uPush'), flat: U('uFlat'), t: U('uT'), gk: U('uGk'), pt: U('uPt'), amt: U('uAmt'), asp: U('uAsp'), tf: U('uTf') };
      // the hologram canvas is twice the book, centred on it, so she can grow out past its edges
      const wr = wrap.getBoundingClientRect(), br = bookEl.getBoundingClientRect(), dpr = Math.min(devicePixelRatio || 1, 2);
      const W = br.width * 2, H = br.height * 2;
      Object.assign(holo.style, { left: (br.left - wr.left - br.width / 2) + 'px', top: (br.top - wr.top - br.height / 2) + 'px', width: W + 'px', height: H + 'px' });
      holo.width = Math.round(W * dpr); holo.height = Math.round(H * dpr); hg.viewport(0, 0, holo.width, holo.height);
      hg.uniform1f(u.asp, 1); hg.uniform1f(u.pt, Math.max(1.8, br.width / 190 * dpr * 1.45));
      // clip space spans 2 book-heights, so a 1-unit-tall figure is exactly the book at scale 1
      wrap.classList.add('is-arming'); glitchMark(); Sfx.hum(3.4);
      const D = 3400, t0 = performance.now(); let landed = false, lastCrack = 0;
      (function frame(now) {
        const p = (now - t0) / D;
        if (p >= 1) { holo.remove(); done(); return; }
        let as, sc, push, rot, flat = 0;
        if (p < .38) { const e = ease.out(p / .38); as = e; sc = .9 + .38 * e; push = .26 * e; rot = -.55 + .4 * e; }
        else if (p < .6) { const e = (p - .38) / .22; as = 1; sc = 1.28 + Math.sin(now * .05) * .01; push = .26; rot = -.15 + .38 * ease.io(e); }
        else { const e = ease.io((p - .6) / .32 > 1 ? 1 : (p - .6) / .32); as = 1; sc = 1.28 - .28 * e; push = .26 * (1 - e); rot = .23 * (1 - e); flat = e; }
        const spike = (p > .45 && p < .52) || (p > .6 && p < .68) || Math.random() < .04;
        if (spike && now - lastCrack > 120) { lastCrack = now; Sfx.crackle(.8); }
        const amt = p < .06 ? (Math.random() > .4 ? .6 : .1) : p < .84 ? 1 : 1 - (p - .84) / .16;
        if (p > .74 && !landed) { landed = true; wrap.classList.remove('is-arming'); setTimeout(() => kick(0, .75), 300); setTimeout(revealBust, 700); }
        hg.clearColor(0, 0, 0, 0); hg.clear(hg.COLOR_BUFFER_BIT);
        hg.uniform1f(u.as, as); hg.uniform1f(u.sc, sc); hg.uniform1f(u.push, push); hg.uniform1f(u.rot, rot); hg.uniform1f(u.flat, flat);
        hg.uniform1f(u.t, now / 1000); hg.uniform1f(u.tf, now / 1000); hg.uniform1f(u.gk, spike ? .9 : .12); hg.uniform1f(u.amt, amt);
        hg.drawArrays(hg.POINTS, 0, N);
        requestAnimationFrame(frame);
      })(t0);
    });
  }
  let introStarted = false;
  new IntersectionObserver((es, ob) => {
    if (introStarted || !es[0].isIntersecting) return;
    introStarted = true; ob.disconnect();
    startIntro(() => { setTimeout(next, 500); scheduleAlive(3500); });
  }, { threshold: .45 }).observe(wrap);

  // ---------- peek inside (module: peek.js) ----------
  if (peekBtn) peekBtn.addEventListener('click', () => { if (window.NBCPeek) { cutAlive(); window.NBCPeek.open(bookEl); } });
  addEventListener('load', () => { if (peekBtn && !window.NBCPeek) peekBtn.hidden = true; });

  // ---------- drop countdown ----------
  const counts = document.querySelectorAll('[data-n14-count]');
  function tick() {
    const ms = DROP - Date.now();
    const txt = ms <= 0 ? 'Out now' : (() => { const s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
      return `${d}d ${String(h).padStart(2, '0')}h ${String(m).padStart(2, '0')}m ${String(x).padStart(2, '0')}s`; })();
    counts.forEach(c => { c.textContent = txt; });
  }
  tick(); const tk = setInterval(() => { tick(); if (DROP - Date.now() <= 0) clearInterval(tk); }, 1000);

  // ---------- notify me (preview: confirms on the page; the theme posts to Shopify's customer form) ----------
  document.querySelectorAll('.n14-notify').forEach(f => f.addEventListener('submit', e => {
    const inp = f.querySelector('input[type=email]');
    if (!inp.value || !inp.checkValidity()) { e.preventDefault(); f.classList.add('is-bad'); inp.focus(); return; }
    f.classList.remove('is-bad');
  }));

  // ---------- teaser phone: play only on screen ----------
  const vid = $('n14Vid');
  new IntersectionObserver(es => { es[0].isIntersecting ? vid.play().catch(() => {}) : vid.pause(); }, { threshold: .2 }).observe(vid);
})();
